export default function useGetMinHeightTableBodyHook(dataLength: number) {
	if (!dataLength) return 0;
	return 40 * Math.min(dataLength, 10);
}
